<template>
    <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-dialog v-model="showPlayer" persistent>
        <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">{{ channel }}</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="stopAndClose" />
        </q-card-section>

        <q-card-section>
          <!-- <VideoPlayer
          ref="videoPlayer"
            style="max-width: 100%; max-height: 100%;"
            :autoPlay="true"
            type="default"
            :link="link"/> -->
            <video-player
            :src="link"
            :width="500"
            :height="400"
            :autoplay="true"
            controls
            :loop="true"
            :volume="0.6"
            :options="{
              reloadSourceOnError: {
                errorInterval: 5,
              }
            }"
            suppressNotSupportedError
          />
        </q-card-section>
      </q-card>
      </q-dialog>
      <q-page class="q-pa-md">
          <div v-for="(section, index) in sections" :key="index" class="q-mb-md">
            <q-item-label header overline style="font-size:20px; font-weight:normal;">{{ section.title }}</q-item-label>
            <div class="row items-center">
              <horizontal-item v-for="item in section.channels" :key="item.id" :item="item" class="q-pa-md" :fun="view" />
            </div>
          </div>
      </q-page>
      </q-page-container>
      </q-layout>
</template>

<script>
import HorizontalItem from "@/components/ItemView";
import { ref } from "vue";
import { getListOfCategories } from "./service/categoryService";
import { VideoPlayer } from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
export default {
  components: {
    HorizontalItem,
    VideoPlayer
  },
  setup() {
    const link = ref("");
    const sections = ref([])
    const showPlayer = ref(false)
    const channel = ref("")
    return {
      sections,
      showPlayer,
      link,
      channel
    }
  },
  methods: {
    stopAndClose() {
      this.showPlayer = false;
      // this.$refs.videoPlayer.pause();
    },
    async list() {
      const resp = await getListOfCategories();
      this.sections = resp.data;
      console.log(this.sections)
    },
    view(i) {
      this.link = i.url;
      this.channel = i.title;
      this.showPlayer = true;
    }
  },
  mounted() {
    this.list();
  },
};
</script>
